<template>
  <div id="manyidu" class="">
    <el-container>
      <div>
        <div style="margin:80px 100px;">
          <div class="question">
            <div>
              <el-row>
                <el-col :span="24">
                  <video id="myVideo" class="video-js vjs-big-play-centered" preload="none" :poster="cover">
                    <source :src="url" type="video/mp4">
                    <p class="vjs-no-js">
                      对不起，您的浏览器太低级，请使用现代浏览器(谷歌浏览器，360浏览器，QQ浏览器等除IE浏览器以外的任意浏览器)             
                    </p>
                  </video>
                  <div style="padding:20px 0;font-size:18px">{{title}}<span style="float:right" v-show="buy"><el-button type="primary" @click="buyCourse">单独购买该课程</el-button><el-button type="primary" @click="buyPackage">开通套餐</el-button></span></div>                
                </el-col>
              </el-row>
            </div>
            <div style="margin-top:100px;">
              <el-row :gutter="60">
                <el-col :span="8">
                  <img :src="cover" alt="" style="width:100%">
                </el-col>
                <el-col :span="16">
                  <div v-html="des" style="font-size:16px;line-height:1.5">
                    {{ des }}
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>
<script>
import { fetchGet,fetchPost } from '../utils/http';
import helpers from '../helper'
export default {
  name:'manyidu',
  data(){
    return {
      id:'',
      url:'',
      cover:'',
      des:'',
      title:'',
      buy:true,
      cover:'',
      myvideo:{}
    }
  },
  methods:{
    buyCourse(){
      let _this = this
      fetchPost('/api/home/api/buyCourse',{
        id: this.id,
      })
      .then((res)=>{        
        if( res.data.code === 10001 ){
          _this.$message({
            message:res.data.msg,
            type:'warning'
          });
          _this.$router.push({name:'login'});
        }
        if( res.data.code === 10002 ){
          _this.$message({
            message:res.data.msg,
            type:'warning'
          });
          _this.$router.push({name:'member-center', params: {activeIndex:'charge'}});
        }
        if( res.data.code === 10003 ){
          _this.$message({
            message:res.data.msg,
            type:'warning'
          });
          this.$router.push({name:'member-center', params: {activeIndex:'charge'}})
        }
        if( res.data.code === 1 ){
          _this.$router.go(0)
        }
      });
    },
    buyPackage(){
      this.$router.push({name:"member-center",params:{activeIndex:"package"}})
    },
    init(){
      //未登录
      let token = sessionStorage.getItem('token')
      if(token == undefined || token == null){
        let _this = this;
        this.$http.post(
          helpers.BASE_URL + '/api/home/index/getTryAndSeeUrl',        
          {id:this.id}
        )
        .then(function(response){
          if(response.data.code === 1 ){
            console.log(response.data.data)
            _this.cover = response.data.data.cover
            _this.id = response.data.data.id
            _this.title = response.data.data.title
            _this.des = response.data.data.des
            let screenWidth = document.body.clientWidth
            let width = screenWidth - 200
            _this.initVideo(width)
          }
        })
      }
      //已登录
      if(sessionStorage.getItem('token') != null){
        let _this = this
        fetchPost('/api/home/api/getKecheng',{
          id: this.id,
        })
        .then((res)=>{
          if( res.data.code === 10002 ){
            _this.$message({
              message:res.data.msg,
              type:'warning'
            });
            _this.$router.push({name:'member-center', params: {activeIndex:'charge'}});
          }
          if( res.data.code === 10003 ){
            _this.$message({
              message:res.data.msg,
              type:'warning'
            });
            this.$router.push({name:'member-center', params: {activeIndex:'charge'}})
          }
          if( res.data.code === 1 ){
            _this.url = res.data.data.url
            _this.cover = res.data.data.cover
            _this.des = res.data.data.des
            _this.buy = res.data.data.buy
            _this.title = res.data.data.title
            let screenWidth = document.body.clientWidth
            let width = screenWidth - 200
            _this.initVideo(width)
            console.log(res.data)
          }
        });
      }
    },
    initVideo(width) {      
      //初始化视频方法
      let myPlayer = this.$video(myVideo, {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: "autoplay",
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          loop:false,
          //设置视频播放器的显示宽度（以像素为单位）
          width: width+'px',
          //设置视频播放器的显示高度（以像素为单位）
          height: '500px'
      },function () {        
        this.play()
      });
      myPlayer.reset()
      console.log(this.url)
      myPlayer.load(this.url)
      myPlayer.src(this.url)
    }
    
  },
  mounted(){
    let vid = this.$route.query.vid
    this.id = vid
    this.init()
  }
}
</script>
<style scoped>
.home{
  background-color: #f4f4f4;
  width: 100%;
}
.bg-image{
  background-image: url('../assets/images/bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
  overflow: hidden;
  width: 100%;
  height: 100vh;  
}
.subtitle{
  margin-top: 40px;
  line-height: 1.5;
  text-align: justify;
}
.item{
  margin-bottom: 100px;
}
.video-img{
  width: 100%;
}
.video-item{
  border: 1px solid #bbbbbb;
}
.play-icon{
  position: absolute;
  width: 60px;
  top: 40%;
  left: 40%;
  cursor: pointer;
  transition: all ease-in .3s;
}
.play-icon:hover{
  transform:scale(1.1);
}
</style>
